"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var ImagePicker = function ImagePicker(props) {
  var trigger = props.trigger,
    onChange = props.onChange;
  var value = _typeof(props.value) === 'object' ? props.value.id : props.value;
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Select image",
    size: "large",
    trigger: trigger,
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.AssetPicker, _extends({
        globalFilter: "image",
        render: function render(_ref2) {
          var body = _ref2.body,
            selectedFile = _ref2.selectedFile;
          return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginTop: '1em'
            }
          }, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary",
            disabled: !selectedFile,
            onClick: function onClick() {
              onChange(selectedFile);
              closeModal();
            }
          }, "Select image")));
        }
      }, value && {
        initialSelectedFile: value
      }));
    }
  });
};
ImagePicker.propTypes = {
  trigger: _propTypes["default"].node,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].object]),
  onChange: _propTypes["default"].func
};
ImagePicker.defaultProps = {
  trigger: /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default"
  }, "Select image")
};
var _default = ImagePicker;
exports["default"] = _default;